import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface ProgressBarProps {
    children?: React.ReactNode;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ children }) => {

    const location = useLocation();

    const barRef = useRef<HTMLDivElement>(null);
    const spinnerRef = useRef<HTMLDivElement>(null);

    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const previousPathRef = useRef(location.pathname);


    const startProgress = () => {

        const bar = barRef.current;
        const spinner = spinnerRef.current;


        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }


        if (bar) {

            bar.style.width = "0%";
            bar.style.opacity = "1";

            let width = 0;


            const animate = () => {

                if (width >= 80) return;


                width += Math.random() * 12 + 5;


                if (width > 80) {
                    width = 80;
                }


                bar.style.width = `${width}%`;

                timerRef.current = setTimeout(animate, 250);
            };


            animate();
        }


        if (spinner) {
            spinner.style.opacity = "1";
        }
    };



    const finishProgress = () => {


        if (timerRef.current) {

            clearTimeout(timerRef.current);

            timerRef.current = null;
        }


        const bar = barRef.current;


        if (bar) {

            bar.style.width = "100%";


            setTimeout(() => {

                bar.style.opacity = "0";


                setTimeout(() => {
                    bar.style.width = "0%";
                }, 200);


            }, 150);
        }



        const spinner = spinnerRef.current;


        if (spinner) {

            setTimeout(() => {
                spinner.style.opacity = "0";
            }, 300);

        }

    };



    useEffect(() => {

        if (previousPathRef.current !== location.pathname) {

            startProgress();


            const timer = setTimeout(() => {
                finishProgress();
            }, 300);


            previousPathRef.current = location.pathname;


            return () => {
                clearTimeout(timer);
            };

        }

    }, [location.pathname]);



    useEffect(() => {

        return () => {

            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

        };

    }, []);



    return (
        <>
            <div
                ref={barRef}
                className="fixed top-0 left-0 h-1 bg-secondary z-[99999] transition-opacity duration-200"
                style={{ width: "0%", opacity: 0 }}
            />


            <div
                ref={spinnerRef}
                className="fixed top-20 right-1/2 z-[99999] transition-opacity duration-300"
                style={{ opacity: 0 }}
            >

                <div className="relative w-8 h-8 p-1 bg-white rounded-full shadow-lg">

                    <div className="absolute inset-0 rounded-full bg-accent/10 blur-sm animate-pulse" />


                    <div className="relative w-full h-full">

                        <div className="absolute inset-0 rounded-full border-2 border-accent/10" />


                        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-accent border-r-accent/60 animate-spin" />


                        <div className="absolute inset-0 flex items-center justify-center">

                            <div className="w-2 h-2 rounded-full bg-accent animate-pulse" />

                        </div>

                    </div>

                </div>

            </div>


            {children}
        </>
    );
};


export default ProgressBar;